import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@recruitee/ngrx';

import { NotificationsCounterFilteredActions } from './notification-counter-filtered.store';
import { NotificationsCounterFilteredHttpService } from './notification-counter-http-filtered.service';

@Injectable({ providedIn: 'root' })
export class NotificationsCounterFilteredEffects {
  public effects = createEffectFactory(NotificationsCounterFilteredActions, this.actions$);

  public fetch$ = this.effects(NotificationsCounterFilteredActions.fetch, ({ payload }) =>
    this.notificationsCounterFilteredHttpService.fetch(payload.filters),
  );

  constructor(
    private actions$: Actions,
    private notificationsCounterFilteredHttpService: NotificationsCounterFilteredHttpService,
  ) {}
}
